// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function ProgressionLineChartsLegend() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Typography fontSize="14px">{t("Legend")}</Typography>
      <Grid container display="flex" rowSpacing="8px" columnSpacing="16px">
        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing="8px"
          columnSpacing="16px"
        >
          <Grid item display="flex" alignItems="center" gap="8px">
            <Typography fontSize="12px" color="#E2772E" fontWeight={600}>
              {t("RetinaLogik Exam")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <Typography fontSize="12px" color="blue" fontWeight={600}>
              {t("External Exam")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container display="flex" rowSpacing="8px" columnSpacing="16px">
        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing="8px"
          columnSpacing="16px"
        >
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "#000",
                borderRadius: "50%",
              }}
            />
            <Typography fontSize="12px" fontWeight={600}>
              {t("Fast Threshold")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "#000",
              }}
            />
            <Typography fontSize="12px" fontWeight={600}>
              {t("Full Threshold")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "0px",
                height: "0px",
                borderLeft: "5px solid transparent",
                borderRight: "5px solid transparent",
                borderBottom: "10px solid #000",
              }}
            />
            <Typography fontSize="12px" fontWeight={600}>
              {t("Standard Threshold")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
